import React, { Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import LoginForm from "./features/auth/pages/LoginPage";
import Dashboard from "./components/Dashboard";
import Hpassword from "./components/shared/Hpassword";
import { Protegerotas } from "./components/shared/protegerotas";
import ErrorBoundary from "./components/shared/ErrorBoundary";
import LoadingFallback from "./components/shared/LoadingFallback";
import AppVersionGate from "./version/AppVersionGate";

export default function App() {
  return (
    <ErrorBoundary>
      <AppVersionGate />
      <Suspense fallback={<LoadingFallback />}>
        <Router>
          <div className="App">
            <Switch>
              <Route path="/" exact component={LoginForm} />

              <Protegerotas path="/home"       component={Dashboard} roles={["Operario", "Director"]} />
              <Protegerotas path="/admin/home" component={Dashboard} roles={["Director"]} />
              <Protegerotas path="/cont/home"  component={Dashboard} roles={["Contabilidade", "Director"]} />
              <Protegerotas path="/irs/home"   component={Dashboard} roles={["IRS", "Director"]} />
              <Protegerotas path="/test/home"  component={Dashboard} roles={["recargatest", "Director"]} />

              <Route path="/reset-password" component={Hpassword} />
              <Route path="/password-reset" component={Hpassword} />

              <Route path="*" render={() => (
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100vh",
                  gap: 12,
                  fontFamily: "Inter, sans-serif",
                  color: "#64748b",
                }}>
                  <span style={{ fontSize: 64, lineHeight: 1, fontWeight: 800, color: "#e2e8f0" }}>404</span>
                  <span style={{ fontSize: 15 }}>Página não encontrada</span>
                </div>
              )} />
            </Switch>
          </div>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}
